/* eslint-disable  */
/* eslint-disable react/prop-types */

import React from 'react';

const Sensor = ({
  id, nombre, checked, onCheckSensor
}) => (
  <div key={id} className="container-checkbox-sensor">
    <label>
      <input type="checkbox" checked={checked} onChange={() => onCheckSensor(id)} />
    </label>
    <p>{`${nombre} `}</p>
  </div>
);

export default Sensor;
